import React from 'react';

const Th = ({ children, right }) => <th className={`px-3 py-2 text-[11px] font-bold uppercase tracking-wide text-gray-400 ${right ? 'text-right' : 'text-left'}`}>{children}</th>;
const Td = ({ children, right, cls = '' }) => <td className={`px-3 py-2 text-sm ${right ? 'text-right tabular-nums' : ''} ${cls}`}>{children}</td>;

const ReportCollaborators = ({ rows, onSelect, selected }) => (
  <div className="bg-white border border-gray-200 rounded-2xl overflow-x-auto" data-testid="report-collaborators">
    <table className="w-full min-w-[640px]">
      <thead className="border-b border-gray-200">
        <tr><Th>Collaborateur</Th><Th right>Affectées</Th><Th right>Terminées</Th><Th right>dont hors affectation</Th><Th right>Non réalisées</Th><Th right>Ouvertes</Th><Th right>Taux</Th></tr>
      </thead>
      <tbody>
        {rows.length === 0 && <tr><td colSpan={7} className="px-3 py-6 text-center text-sm text-gray-500">Aucune donnée pour cette période.</td></tr>}
        {rows.map(c => (
          <tr key={c.id} onClick={() => onSelect?.(c)} className={`border-b border-gray-100 last:border-0 cursor-pointer hover:bg-gray-50 ${selected === c.id ? 'bg-neon-pink/5' : ''}`} data-testid={`report-collab-row-${c.id}`}>
            <Td cls="font-semibold text-gray-900">{c.name}</Td>
            <Td right>{c.affectees}</Td>
            <Td right cls="text-emerald-700 font-semibold">{c.terminees}</Td>
            <Td right cls="text-amber-700">{c.terminees_hors_affectation || 0}</Td>
            <Td right cls="text-red-700">{c.non_realisees}</Td>
            <Td right cls="text-blue-700">{c.ouvertes}</Td>
            <Td right cls="font-semibold">{c.taux_realisation == null ? '—' : `${c.taux_realisation} %`}</Td>
          </tr>
        ))}
      </tbody>
    </table>
    <p className="px-3 py-2 text-xs text-gray-400">Taux = tâches affectées au collaborateur et terminées par lui / tâches affectées. « Hors affectation » = terminées par lui sans y être affecté.</p>
  </div>
);

export default ReportCollaborators;
